import React, {useState, useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BasicText from '../DebtPaymentComponents/basicText';
import BasicImage from '../DebtPaymentComponents/basicImage';
import {errorEnum} from '../DebtPaymentComponents/debtPaymentEnum';
import Action from '../DebtPaymentComponents/action';
import Config from '../../../../Config';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {numWithStarRTL} from '../../../../utilities/StringHelpers/StringHelpers';
import {CSSTransition} from 'react-transition-group';
import {report, getReportParams} from '../../../../middleware/report';

import '../debtPayment.scss';
import '../debtPaymentAnimations.scss';

const LowAmountError = (props) => {
  const [mount, setMount] = useState(false);

  let mainImg = require('../images/icons-error.svg');

  let title = 'שירות זה אינו זמין';
  let dial = require('../images/icons-call-phone.svg');
  let actionText = props.isMobile ? 'חיוג ' + numWithStarRTL(Config.businessCallNumber) + 'לאחראי שירות' : 'לפנייה לנציג שירות יש לחייג למספר ';

  useEffect(() => {
    if (props.currentStep === errorEnum.LOWAMOUNT) {
      setMount(true);
      gaEvent(
        gaParams.PRIVATEDEBT_SPECIALERROR_SHOW.category,
        gaParams.PRIVATEDEBT_SPECIALERROR_SHOW.eventType,
        `היתרה בחשבונך הינה 0 ש"ח\nנכון למועד זה אין חיוב לשלם ${window.Config.brand_Name_HE}`,
      );
    } else {
      setMount(false);
    }
  }, [props.currentStep]);

  return (
    <CSSTransition key={18} in={mount} timeout={250} classNames='stepwrapper' mountOnEnter unmountOnExit>
      <Container fluid className='debtpayment-step'>
        <Row className='debtpayment-container justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='תשלום חוב' classname='debtpayment-title' />
          </Col>
        </Row>
        <Row className='debtpayment-step-title justify-content-md-center'>
          <Col md='auto'>
            <BasicText text={'לא ניתן להשלים\nאת הפעולה'} classname={'main-text-extra-bold'} />
          </Col>
        </Row>
        <Row className='debtpayment-step-subtitle justify-content-md-center'>
          <Col md='auto'>
            <BasicText text={`היתרה בחשבונך הינה 0 ש"ח\nנכון למועד זה אין חיוב לשלם ב${window.Config.brand_Name_HE}`} />
          </Col>
        </Row>
        <Row className='justify-content-md-center main-img'>
          <Col md='auto'>
            <BasicImage src={mainImg} />
          </Col>
        </Row>
        <Row className='justify-content-md-center footer-btn'>
          <Col md='auto'>
            <BtnSubmit formid='' text='סיום' onclick={props.onclick} />
          </Col>
        </Row>
      </Container>
    </CSSTransition>
  );
};

export default LowAmountError;
